import styles from './formerrordisplay.module.scss';

export interface FormErrorDisplayProps {
    errorCount: number;
}

export function FormErrorDisplay({ errorCount }: FormErrorDisplayProps): React.JSX.Element {
    if (errorCount === 0) {
        return <></>;
    }

    return (
        <div className={styles.errorMessage} role="alert">
            {`Please fix the ${errorCount} error${errorCount > 1 ? 's' : ''} in the form below`}
        </div>
    );
}
